export default {
  '478': '验证码错误,请重新输入',
  '479': '演示环境，没有权限操作',
  '401': '用户名不存在或密码错误',
  '403': '当前操作没有权限',
  '400': '用户名不存在或密码错误',
  '429': '请求过频繁',
  '500': '系统错误,请反馈给管理员',
  'default': '系统未知错误,请反馈给管理员'
}
